import React from 'react'
import { BoxComponent } from './styled'
import usePreventSpace from '~/components/hooks/use-prevent-space'
import styled from 'styled-components'
import useKeyboardAction from '~/components/hooks/use-keyboard-action'

const Box = ({ children, className, disabled, callback, ...rest }) => {
  const handleKeyDown = usePreventSpace()

  const handleClick = () => {
    if (disabled) {
      return
    }

    callback?.()
  }

  const handleKeyUp = useKeyboardAction(callback, disabled)

  return (
    <BoxComponent
      className={className}
      disabled={disabled}
      role={disabled ? 'none' : 'button'}
      tabIndex={disabled ? -1 : 0}
      onKeyDown={handleKeyDown}
      onKeyUp={handleKeyUp}
      onClick={handleClick}
      {...rest}
    >
      {children}
    </BoxComponent>
  )
}

export default styled(Box)``
